/**
 * CardCarousel.js — Horizontal card carousel + optional wine pagination.
 *
 * Renders message.data.items with the registered card component for
 * message.data.cardType. For wine listings, when BE pagination is present,
 * appends shared page controls under the track — parity with old
 * createWineListing + createWinePagination (shows even when total_pages is 1).
 */

import { registry } from "../../../core/registry.js";
import { createWinePagination } from "./winePagination.js";
import { attachCarouselNav } from "./carouselNav.js";

function componentNameFor(type) {
  if (!type) return null;
  return type.charAt(0).toUpperCase() + type.slice(1) + "Card";
}

export default class CardCarousel {
  render(message, ctx) {
    const items = message.data?.items || [];
    const cardType = message.data?.cardType;
    if (!items.length || !cardType) return null;

    const CardComponent = registry.getComponent(componentNameFor(cardType));
    if (!CardComponent) {
      console.warn(
        `[RedConcierge] No card component registered for type: ${cardType}`,
      );
      return null;
    }

    const wrap = document.createElement("div");
    wrap.className = "ws-carousel";
    if (cardType === "wine") {
      wrap.classList.add("ws-wine-listing");
      wrap.dataset.listingType = message.data.listingType || "wine_listing";
      wrap.dataset.listingMessage =
        message.data.listingMessage || "Show me all available wines";
      if (message.data.foodPairingsTaskId) {
        wrap.dataset.foodPairingsTaskId = message.data.foodPairingsTaskId;
      }
      if (message.data.pagination) {
        wrap.dataset.winePagination = JSON.stringify(message.data.pagination);
      }
    }

    const track = document.createElement("div");
    track.className = "ws-carousel-track";

    items.forEach((item) => {
      const card = new CardComponent().render(item, ctx);
      if (!card) return;
      card.classList.add("ws-carousel-item");
      track.appendChild(card);
    });

    if (!track.children.length) return null;

    wrap.appendChild(track);
    attachCarouselNav(wrap, track);

    // ⚠ SHARED/BASE — all tenants. Wine Shop Our Wines pagination.
    if (cardType === "wine" && message.data?.pagination) {
      const pager = createWinePagination(message.data.pagination, {
        messageId: message.id,
        listingMessage: message.data.listingMessage,
        listingType: message.data.listingType,
        foodPairingsTaskId: message.data.foodPairingsTaskId,
      });
      if (pager) wrap.appendChild(pager);
    }

    return wrap;
  }
}
